import image1 from "../../imgs/header/star.png";
import image2 from "../../imgs/header/flower.png";
import image3 from "../../imgs/header/heart.png";

export const images = {
  image1,
  image2,
  image3,
};
